import { useFlags } from "flagsmith/react";
import { useGetCustomerSetupChecklist } from "@/requests/hooks/user";
import { IFeatureFlagKeys, isFeatureFlagEnabled } from "@/utils/featureFlags";

// Based on CustomerSetupChecklistStep enum from the backend
export enum SetupChecklistStep {
  INSTALL_DATASHIPS_APP = "INSTALL_DATASHIPS_APP",
  CONNECT_MAT_APP = "CONNECT_MAT_APP",
  INSTALL_MAT_APP = "INSTALL_MAT_APP",
  CONFIGURE_MAT_APP = "CONFIGURE_MAT_APP",
  CONFIGURE_PRIVACY_DETAILS = "CONFIGURE_PRIVACY_DETAILS",
  CONFIGURE_CHECKOUT = "CONFIGURE_CHECKOUT",
  CONFIGURE_DATASHIPS_APP = "CONFIGURE_DATASHIPS_APP",
}

interface OnboardingStep {
  id: SetupChecklistStep;
  completed: boolean;
}

interface OnboardingStatus {
  isOnboarding: boolean;
  url: string;
  steps: OnboardingStep[];
  completedSteps: number;
  totalSteps: number;
}

export const useOnboardingStatus = () => {
  const flags = useFlags<IFeatureFlagKeys>(["web-app-mat-onboarding-enabled"]);
  const isWebAppMatOnboardingEnabled = isFeatureFlagEnabled(
    flags["web-app-mat-onboarding-enabled"],
  );
  const { data, isLoading, error } = useGetCustomerSetupChecklist(
    isWebAppMatOnboardingEnabled,
  );

  let isOnboarding = false;
  let steps: OnboardingStep[] = [];
  let completedSteps = 0;
  let totalSteps = 0;

  if (data && Array.isArray(data)) {
    steps = data.map(step => ({
      id: step.item as SetupChecklistStep,
      completed: step.completed,
    }));

    isOnboarding = steps.length > 0 && steps.some(step => !step.completed);

    completedSteps = steps.filter(step => step.completed).length;
    totalSteps = steps.length;
  }

  const onboardingStatus: OnboardingStatus = {
    isOnboarding,
    url: "/integrations/checklist",
    steps,
    completedSteps,
    totalSteps,
  };

  return {
    onboardingStatus,
    isLoading,
    error,
  };
};
